import { countriesFilter } from 'api/queryFilters';
import xhr from 'xhr';

export default async function getCountries() {
  const response = await xhr(`/countries?${countriesFilter()}`);

  return response.data.data;
}
